const blockElements = new Set(['blockquote', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']);

export const htmlToPlainText = (html: string) => {
  const container = document.createElement('div');
  container.innerHTML = html;

  const readNode = (node: Node): string => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent ?? '';
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }

    const element = node as HTMLElement;
    const tagName = element.tagName.toLowerCase();
    const childText = Array.from(element.childNodes).map(readNode).join('');

    if (tagName === 'br') {
      return '\n';
    }

    if (tagName === 'ol' || tagName === 'ul') {
      return Array.from(element.children)
        .map((child, index) => {
          const marker = tagName === 'ol' ? `${index + 1}. ` : '- ';
          return `${marker}${Array.from(child.childNodes).map(readNode).join('').trim()}\n`;
        })
        .join('');
    }

    if (tagName === 'td' || tagName === 'th') {
      return `${childText.trim()}\t`;
    }

    if (tagName === 'tr' || tagName === 'li') {
      return `${childText.trim()}\n`;
    }

    if (tagName === 'pre') {
      return `${childText.replace(/\n+$/g, '')}\n\n`;
    }

    if (blockElements.has(tagName)) {
      return `${childText.trim()}\n\n`;
    }

    return childText;
  };

  return Array.from(container.childNodes)
    .map(readNode)
    .join('')
    .replace(/\t+\n/g, '\n')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .replace(/^\n+|\n+$/g, '');
};
